import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../static/icons/upload_icon.svg'
import _imports_1 from '../../../static/images/fallback_image.png'
import _imports_2 from '@/static/icons/trash_icon.svg'


const _hoisted_1 = { class: "decoration-upload" }
const _hoisted_2 = { class: "decoration-upload__title" }
const _hoisted_3 = {
  key: 0,
  for: "decoration-upload__file-upload",
  class: "secondary-button decoration-upload__upload-label"
}
const _hoisted_4 = {
  key: 1,
  class: "decoration-upload__error-message"
}
const _hoisted_5 = {
  key: 2,
  class: "decoration-upload__recommended-types-text"
}
const _hoisted_6 = {
  key: 3,
  class: "decoration-upload__recommended-types-examples"
}
const _hoisted_7 = {
  key: 4,
  class: "decoration-upload__uploaded"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "decoration-upload__uploaded-image",
  src: _imports_1,
  alt: "Your uploaded image"
}
const _hoisted_10 = { class: "decoration-upload__uploaded-description" }
const _hoisted_11 = { class: "decoration-upload__uploaded-texts" }
const _hoisted_12 = { class: "decoration-upload__uploaded-name" }
const _hoisted_13 = { class: "decoration-upload__uploaded-size" }

import { ref, computed, inject } from 'vue';
import { injectionKeys as litiumKeys } from '@motillo/drapejs-litium';
import useContext from '@/composables/useContext';
import * as config from '@/config';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { configuratorStateKey } from '../ProductConfiguratorKeys';

const SIZE_LIMIT_IN_MB = 5;

export default /*@__PURE__*/_defineComponent({
  __name: 'DecorationUpload',
  props: {
  upload: {
    type: Object,
    default: null
  }
},
  emits: ['upload', 'remove'],
  setup(__props, { emit: __emit }) {

const { isAuthorized, route, navigateToLoginPage, channel, user } =
  useContext();
const toLitiumMediaUrl = inject(litiumKeys.toLitiumMediaUrlKey, () => '');
const { websiteText } = useWebsiteTexts();
const emit = __emit;
const { configuratorState } = inject(configuratorStateKey);

const props = __props;

const hasImageSizeWarning = ref(false);
const displayFileSize = computed(() => {
  if (!props.upload?.Size) return '';
  const { Size } = props.upload;
  return Size < 1 ? `${Math.round(Size * 1024)} kB` : `${Math.round(Size)} mB`;
});
const imageSource = computed(() => {
  const id = props.upload.SystemId;
  return toLitiumMediaUrl(id, { maxWidth: 124 });
});

const showDefaultImage = ref(false);

function displayDefaultImage() {
  showDefaultImage.value = true;
}

const requestContext = computed(() => ({
  channelSystemId: channel.value.systemId,
  websiteSystemId: channel.value.website?.systemId,
  culture: channel.value.locale
}));

function removeImage() {
  showDefaultImage.value = false;
  emit('remove');
}

function handleImage(e) {
  if (!isAuthorized()) {
    const search = route?.query || {};
    const query = {
      ...search,
      progress: 'product-configuration'
    };

    sessionStorage.setItem(
      'product-configuration',
      JSON.stringify(configuratorState.value)
    );
    navigateToLoginPage(query);
    return;
  }

  if (!e.target.files || e.target.files.length === 0) {
    return;
  }
  hasImageSizeWarning.value = false;
  const image = e.target.files[0];
  const imgSize = parseFloat((image.size / 1024 / 1024).toFixed(5));

  if (imgSize > SIZE_LIMIT_IN_MB) {
    hasImageSizeWarning.value = true;
    return;
  }

  const formData = new FormData();
  formData.append('file', image);
  formData.append('user', user.value?.organization?.organizationNo);

  fetch(`${config.litiumBaseUrl}/api/productprint`, {
    method: 'POST',
    body: formData,
    headers: {
      'litium-request-context': JSON.stringify(requestContext.value)
    }
  })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }

      return response.json();
    })
    .then((data) => {
      const imageData = data;
      imageData.Size = imgSize;
      emit('upload', imageData);
    })
    .catch((error) => {
      console.log('Couldnt upload image', error);
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(websiteText)('decoration__add_logo').value), 1),
    (!__props.upload)
      ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
          _createElementVNode("input", {
            type: "file",
            id: "decoration-upload__file-upload",
            class: "decoration-upload__upload-button",
            accept: ".eps, .pdf, .ai, .png, .jpg, .jpeg, .ps",
            onChange: handleImage
          }, null, 32),
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            src: _imports_0,
            alt: "upload-icon"
          }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(websiteText)('global__select_file').value), 1)
        ]))
      : _createCommentVNode("", true),
    (hasImageSizeWarning.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(websiteText)('decoration__size_error', {
          maxsize: SIZE_LIMIT_IN_MB.toString()
        }).value), 1))
      : _createCommentVNode("", true),
    (!__props.upload)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(websiteText)('decoration__file_recommendation').value), 1))
      : _createCommentVNode("", true),
    (!__props.upload)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(websiteText)('decoration__file_examples').value), 1))
      : _createCommentVNode("", true),
    (__props.upload)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (!showDefaultImage.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "decoration-upload__uploaded-image",
                src: imageSource.value,
                alt: "Your uploaded image",
                onError: displayDefaultImage
              }, null, 40, _hoisted_8))
            : _createCommentVNode("", true),
          (showDefaultImage.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(__props.upload.Name), 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(displayFileSize.value), 1)
            ]),
            _createElementVNode("img", {
              class: "decoration-upload__uploaded-remove",
              src: _imports_2,
              alt: "trashcan icon",
              onClick: removeImage
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})